"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: circleRef,
    isVisible: circleVisible
  } = useRevealOnScroll<SVGSVGElement>({
    threshold: 0.4
  });
  return <section data-section-id="1868" id="cookieinformationhero" className="relative bg-background overflow-hidden py-32 md:py-44">
      {}
      <svg className="absolute top-12 right-8 w-32 h-32 md:w-48 md:h-48 opacity-15 pointer-events-none hidden md:block" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M100 20 Q105 60 100 100 Q95 140 100 180" stroke="var(--foreground)" strokeWidth="1.5" strokeLinecap="round" fill="none" />
        <path d="M100 40 Q80 45 65 55" stroke="var(--foreground)" strokeWidth="1.25" strokeLinecap="round" fill="none" />
        <path d="M100 40 Q120 45 135 55" stroke="var(--foreground)" strokeWidth="1.25" strokeLinecap="round" fill="none" />
        <path d="M100 70 Q78 78 60 92" stroke="var(--foreground)" strokeWidth="1.25" strokeLinecap="round" fill="none" />
        <path d="M100 70 Q122 78 140 92" stroke="var(--foreground)" strokeWidth="1.25" strokeLinecap="round" fill="none" />
        <path d="M100 100 Q76 110 56 128" stroke="var(--foreground)" strokeWidth="1.25" strokeLinecap="round" fill="none" />
        <path d="M100 100 Q124 110 144 128" stroke="var(--foreground)" strokeWidth="1.25" strokeLinecap="round" fill="none" />
        <path d="M100 130 Q80 140 66 158" stroke="var(--foreground)" strokeWidth="1.25" strokeLinecap="round" fill="none" />
        <path d="M100 130 Q120 140 134 158" stroke="var(--foreground)" strokeWidth="1.25" strokeLinecap="round" fill="none" />
        <ellipse cx="65" cy="55" rx="8" ry="3" fill="var(--foreground)" opacity="0.6" />
        <ellipse cx="135" cy="55" rx="8" ry="3" fill="var(--foreground)" opacity="0.6" />
        <ellipse cx="60" cy="92" rx="9" ry="3.5" fill="var(--foreground)" opacity="0.6" />
        <ellipse cx="140" cy="92" rx="9" ry="3.5" fill="var(--foreground)" opacity="0.6" />
        <ellipse cx="56" cy="128" rx="10" ry="4" fill="var(--foreground)" opacity="0.6" />
        <ellipse cx="144" cy="128" rx="10" ry="4" fill="var(--foreground)" opacity="0.6" />
      </svg>

      <div className="mx-auto max-w-[1320px] px-8 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {}
          <div ref={leftRef} className={`lg:col-span-7 order-2 lg:order-1 transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
        }}>
            {}
            <div className="flex items-center gap-3 mb-8 md:mb-10">
              <span className="font-mono text-[11px] md:text-[13px] tracking-[0.18em] uppercase font-medium text-foreground">
                № 01 — Guida Indipendente
              </span>
              <span className="inline-block w-2 h-2 rotate-45 bg-primary" aria-hidden="true" />
            </div>

            {}
            <h1 className="font-default font-bold text-foreground mb-10" style={{
            fontSize: "clamp(3.25rem, 7vw, 6.5rem)",
            letterSpacing: "-0.025em",
            lineHeight: "0.95"
          }}>
              <span className="block">Risparmia fino al</span>
              <span className="block">70% sui tuoi</span>
              <span className="block">impianti dentali</span>
              <span className="block">
                in{" "}
                <span className="relative inline-block">
                  <span className="font-bold text-primary relative z-10 px-2" style={{
                  fontSize: "clamp(3.5rem, 7.5vw, 7rem)",
                  lineHeight: "0.9"
                }}>
                    Albania
                  </span>
                  <svg ref={circleRef} className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 280 120" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M 30 60 Q 20 20, 80 15 Q 160 8, 230 18 Q 270 28, 260 65 Q 252 100, 180 108 Q 90 115, 40 100 Q 12 85, 30 60 Z" stroke="var(--primary)" strokeWidth="2.5" strokeLinecap="round" fill="none" style={{
                    strokeDasharray: 700,
                    strokeDashoffset: circleVisible ? 0 : 700,
                    transition: "stroke-dashoffset 900ms ease-out"
                  }} />
                  </svg>
                </span>
                .
              </span>
            </h1>

            {}
            <p className="font-default text-foreground/85 max-w-xl mb-10" style={{
            fontSize: "clamp(1.125rem, 1.3vw, 1.375rem)",
            lineHeight: "1.55"
          }}>
              La guida definitiva per i pazienti italiani: scopri come ottenere cure odontoiatriche di eccellenza a prezzi trasparenti, evitando le trappole del turismo dentale.
            </p>

            {}
            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 hover:-translate-y-0.5 transition-all duration-200 font-default uppercase tracking-[0.05em] text-xs md:text-sm font-medium px-7 py-6 rounded-lg shadow-md">
                <Link to="/AboutUsPage">Scopri il Metodo</Link>
              </Button>
              <Button asChild variant="outline" className="bg-transparent border border-foreground text-foreground hover:bg-foreground hover:text-background transition-colors duration-200 font-default uppercase tracking-[0.05em] text-xs md:text-sm font-medium px-7 py-6 rounded-lg">
                <Link to="/HomePage">Confronta i Prezzi</Link>
              </Button>
            </div>

            {}
            <div className="flex items-center gap-0 mb-6 max-w-md">
              <span className="flex-1 h-px bg-border" />
              <span className="w-1.5 h-1.5 rounded-lg bg-primary" aria-hidden="true" />
            </div>

            {}
            <p className="font-default text-foreground/70 text-sm md:text-base tracking-[0.005em]">
              — Guida aggiornata al 2026 per pazienti informati
            </p>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-5 order-1 lg:order-2 transition-all duration-700 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
          transitionDelay: "120ms"
        }}>
            <div className="relative w-full max-w-md mx-auto lg:max-w-none">
              {}
              <span className="absolute -top-3 -left-3 w-4 h-4 border-t-2 border-l-2 border-primary z-10" aria-hidden="true" />
              <span className="absolute -top-3 -right-3 w-4 h-4 border-t-2 border-r-2 border-primary z-10" aria-hidden="true" />
              <span className="absolute -bottom-3 -left-3 w-4 h-4 border-b-2 border-l-2 border-primary z-10" aria-hidden="true" />
              <span className="absolute -bottom-3 -right-3 w-4 h-4 border-b-2 border-r-2 border-primary z-10" aria-hidden="true" />

              <div className="relative overflow-hidden rounded-lg bg-card border border-border shadow-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663456/img/dental_clinic_consultation_albania.png" alt="Paziente italiano in consultazione presso una moderna clinica odontoiatrica a Tirana" loading="lazy" decoding="async" className="w-full h-auto object-cover aspect-[4/5]" />
              </div>

              {}
              <p className="font-default text-foreground/70 text-xs md:text-sm tracking-[0.005em] mt-5 text-right">
                — Strutture certificate e tecnologie all'avanguardia
              </p>
            </div>
          </div>
        </div>
      </div>

      {}
      <svg className="absolute bottom-0 left-0 w-full h-6 pointer-events-none" viewBox="0 0 1440 24" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M0 24 L0 14 Q40 8, 80 12 T160 10 Q200 6, 240 13 T320 11 Q360 4, 400 12 T480 9 Q520 14, 560 8 T640 12 Q680 5, 720 11 T800 9 Q840 14, 880 7 T960 12 Q1000 6, 1040 13 T1120 10 Q1160 4, 1200 11 T1280 8 Q1320 13, 1360 9 T1440 12 L1440 24 Z" fill="var(--background)" />
      </svg>
    </section>;
}